<template>
    <div class="card">
        <div class="card-header">
            <h5>Tour Instance Flight Budgets</h5>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-4">
                    <label class="form-label">Tour Name</label> 
                    <v-select
                        :options="tours"
                        label="name"
                        class="m-0"
                        id="tour"
                        index="id"
                        v-model="selectedTour"
                    />
                </div>
                <div class="col-md-5">
                    <div class="row">
                        <div class="col-md-12">
                            <h6>Departure Date Range</h6>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-6">
                        <dateTimePicker
                            no-label
                            label="From Date"
                            id="departureDateStart"
                            format="YYYY-MM-DD"
                            formatted="YYYY-MM-DD"
                            v-model="departureStartDate"
                            button-color="#ec391e"
                            :only-date="true"
                            color="#ec391e"
                            style="border: 1px solid #DFE5F9"
                        />
                        </div>
                        <div class="col-md-6">
                            <dateTimePicker
                                no-label
                                label="To Date"
                                id="departureDateEnd"
                                format="YYYY-MM-DD"
                                formatted="YYYY-MM-DD"
                                v-model="departureEndDate"
                                button-color="#ec391e"
                                :only-date="true"
                                color="#ec391e"
                                style="border: 1px solid #DFE5F9"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <button type="submit" class="button" style="margin-top: 32px;" @click="fetchFlightBudgets">
                        Get report    
                    </button>
                    &nbsp;
                    <button type="submit" class="btn btn-success" @click="exportFlightBudgets">
                        Export
                    </button>
                </div>
            </div>
            <hr/>
            <div class="row mt-3">
                <div class="col-md-12">
                    <div class="table-responsive" v-if="flightBudgets.data.length > 0">
                        <table class="table table-bordered">
                            <tbody>
                                <template v-for="(tour, index) in flightBudgets.data">
                                    <tr class="table-secondary" :key="index">
                                        <td colspan="6" class="fw-bold">{{ tour.name }}</td>
                                    </tr>
                                    <template v-for="(group, group_index) in tour.groups">
                                        <tr class="table-info" :key="group_index">
                                            <td colspan="6" class="fw-bold">{{ group.start_date | formatDate }}</td>
                                        </tr>
                                        <tr :key="group_index">
                                            <th>Airport</th>
                                            <th>Flight Budget</th>
                                            <th>Actual Flight Cost</th>
                                            <th>Base Price</th>
                                            <th>New Base Price</th>
                                            <th></th>
                                        </tr>
                                        <tr v-for="(instance, instance_index) in group.instances" :key="instance_index">
                                            <td>{{ instance.airport.airport_name }}</td>
                                            <td>
                                                <template v-if="instance.budgeted_cost">
                                                    {{ instance.budgeted_cost | formatCurrency }}
                                                </template>
                                                <template v-else>
                                                    {{ 0 | formatCurrency }}
                                                </template>
                                            </td>
                                            <td class="text-danger">
                                                {{ 0 | formatCurrency }}
                                            </td>
                                            <td>{{ instance.base_price | formatCurrency }}</td>
                                            <td>
                                                <div class="form-group">
                                                  <input type="number" 
                                                    class="form-control" 
                                                    min="0"
                                                    v-model="instance.updated_base_price" />
                                                  <small class="text-primary form-text">**Estimated Base Price: {{ instance.base_price | formatCurrency }}</small>
                                                </div>
                                            </td>
                                            <td>
                                                <div class="row">
                                                    <!-- <div class="col-md-4">
                                                        <button class="btn btn-sm btn-outline-primary me-2" title="Update Base Price">
                                                            <i class="icon icon--update"></i>
                                                        </button>
                                                    </div> -->
                                                    <div class="col-md-4">
                                                        <button class="btn btn-sm btn-outline-secondary" title="View Flight Price History" @click="previewHistory(tour.id, group.id, instance.id)"> 
                                                            <i class="icon icon--eye"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                &nbsp;
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                                <tr>
                                    <td colspan="6" class="text-end fw-bold" @click="updateBasePriceOfAll">
                                        <button class="button">Update/Save All</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="text-center text-muted py-4">
                        No data available. Please select filters and click "Get report".
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="historyData">
            <div class="col-md-12">
                <!-- Flight Budget History -->
                <div class="modal-sm" v-if="flightBudgetHistoryModal == true">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title"> Tour Instance Flight Budget History </h3>
                    </div>
                    <div class="modal-body">
                        <div class="row mt-2">
                            <div class="col-md-12">
                                <u>{{ historyData.tourName }}</u> - <u>{{ historyData.groupStartDate | formatDate }}</u> - <u>{{ historyData.airportName }}</u>
                            </div>
                        </div>
                        <hr />
                        <div class="row">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Flight Price</th>
                                                <th>Synced On</th>
                                                <th>Message</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="historyData.history.length > 0">
                                                <tr v-for="(data, index) in historyData.history" :key="index">
                                                    <td>{{ Number(data.estimated_flight_cost) | formatCurrency }}</td>
                                                    <td>{{ data.sync_date | formatDate }}</td>
                                                    <td>
                                                        <template v-if="data.error_log">
                                                            <pre style="background-color: #f5f5f5; padding: 8px; border-radius: 4px; max-height: 200px; overflow-y: auto; font-size: 12px;">{{ formatErrorLog(data.error_log) }}</pre>
                                                        </template>
                                                        <template v-else>
                                                            <span class="text-muted">No errors</span>
                                                        </template>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr>
                                                    <td colspan="3" class="text-center text-muted">No history available.</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <button type="button" class="icon icon--unlink" v-on:click="flightBudgetHistoryModal = false"></button>
                </div>
                <div class="modal__bg" v-if="flightBudgetHistoryModal == true"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TourInstanceFlightBudgets",
    props: {
        tours: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            selectedTour: null,
            departureStartDate: '',
            departureEndDate: '',
            flightBudgets: {
                recordsPerPage: 25,
                start: 0,
                data: [],
                total: 0
            },
            flightBudgetHistoryModal: false,
            historyData: {}
        }
    },
    methods: {
        formatErrorLog(errorLog) {
            try {
                // If it's already a string, try to parse it
                if (typeof errorLog === 'string') {
                    const parsed = JSON.parse(errorLog);
                    return JSON.stringify(parsed, null, 2);
                }
                // If it's an object, stringify it with formatting
                return JSON.stringify(errorLog, null, 2);
            } catch (e) {
                // If parsing fails, return as is
                return errorLog;
            }
        },
        fetchFlightBudgets() {
            const filters = {
                tours: this.selectedTour,
                departure_start: this.departureStartDate,
                departure_end: this.departureEndDate,
                start: this.flightBudgets.start,
                length: this.flightBudgets.recordsPerPage
            };

            this.$store.dispatch("setLoadStatus");
            fetch(this.$api + 'reports/flight-budget-report', {
                method: 'POST',
                body: JSON.stringify({filters: filters}),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then(res => res.json())
            .then((res) => {
                this.$store.dispatch("setLoadStatus");
                if(res.status) {
                    this.flightBudgets = res.data;
                }
            })
            .catch((error) => {
                this.$store.dispatch("setLoadStatus");
                console.error('Error fetching flight budgets:', error);
            })
        },
        updateBasePriceOfAll() {
            let updates = [];
            this.flightBudgets.data.forEach(tour => {
                tour.groups.forEach(group => {
                    group.instances.forEach(instance => {
                        if(instance.updated_base_price && instance.updated_base_price != instance.base_price) {
                            updates.push({ id: instance.id, new_base_price: Number(instance.updated_base_price) }); 
                        }
                    });
                });
            });

            this.$swal.fire({
                title: 'Are you sure?',
                text: `You are about to update base prices for ${updates.length} instances.`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, update it!',
                cancelButtonText: 'Cancel'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch("setLoadStatus");
                    fetch(this.$api + 'budgets/update-instance-budgets', {
                        method: 'POST',
                        body: JSON.stringify({instance_budgets: updates}),
                        headers:{
                            'Content-Type': 'application/json',
                            'Accept': 'application/json',
                            'Authorization': localStorage.getItem('token')
                        }
                    })
                    .then(res => res.json())
                    .then((res) => {
                        this.$store.dispatch("setLoadStatus");
                        if(res.status) {
                            this.$swal.fire('Updated!', res.message, 'success');
                            this.fetchFlightBudgets();
                        } else {
                            this.$swal.fire('Error!', res.message, 'error');
                        }
                    })
                    .catch((error) => {
                        this.$store.dispatch("setLoadStatus");
                        console.error('Error updating base prices:', error);
                        this.$swal.fire('Error!', 'An error occurred while updating base prices.', 'error');
                    });
                }
            });
            
        },
        previewHistory(tourId, groupId, instanceId) {
            let self = this
            this.flightBudgets.data.forEach(tour => {
                if(tour.id === tourId) {
                    tour.groups.forEach(group => {
                        if(group.id === groupId) {
                            group.instances.forEach(instance => {
                                if(instance.id === instanceId) {
                                    self.historyData = {
                                        tourName: tour.name,
                                        groupStartDate: group.start_date,
                                        airportName: instance.airport.airport_name,
                                        history: instance.instance_flight_budgets
                                    }
                                }
                            });
                        }
                    });
                }
            });
            // console.log(self.historyData);
            self.flightBudgetHistoryModal = true;
            
        },
        exportFlightBudgets() {
            const filters = {
                tours: this.selectedTour,
                departure_start: this.departureStartDate,
                departure_end: this.departureEndDate
            };

            this.$store.dispatch("setLoadStatus");
            fetch(this.$api + 'reports/flight-budget-report/export', {
                method: 'POST',
                body: JSON.stringify({...filters}),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            })
            .then((res) => {
                // check if response have no error
                if (!res.ok) {
                    return res.json().then(err => { throw new Error(err.message || 'Error exporting flight budgets'); });
                } else {
                    return res.blob();
                }   
            })
            .then((blob) => {
                this.$store.dispatch("setLoadStatus");
                // Create a link to download the file
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `tour_instance_flight_budgets_${new Date().toISOString().slice(0,10)}.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
            .catch((error) => {
                this.$store.dispatch("setLoadStatus");
                this.$swal.fire('Error!', error.message, 'error');
                console.error('Error exporting flight budgets:', error);
            })
        }
    }
}
</script>
